module.exports = __webpack_public_path__ + "img/voet.1d5a3dc1.png";